import { loaderContainer } from "../utils/style";
import { useMemo, useState } from "react";

export var setLoader;

function Loader() {
    const [showLoader, setShowLoader] = useState(false);

    setLoader = function (state) {
        setShowLoader(state);
    };

    const loaderContent = useMemo(() => (
        <div className="px-6 py-4 rounded-xl bg-white text-primary text-base font-semibold shadow-2xl flex items-center gap-4 border border-primary-light">
            <div className="w-5 h-5 border-4 border-primary-light border-t-primary rounded-full animate-spin"></div>
            <span>Loading...</span>
        </div>
    ), []);

    if (!showLoader) {
        return null;
    }

    return (
        <div className={loaderContainer}>
            {loaderContent}
        </div>
    );
}

export default Loader;